import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "relation-vocabulary-failed font-second"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.vocabulary)
    ? _renderSlot(_ctx.$slots, "default", { key: 0 }, undefined, true)
    : (_ctx.failed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[1] || (_cache[1] = _createElementVNode("p", null, "The apparatus signs could not be loaded.", -1)),
          _createElementVNode("button", {
            class: "button is-small",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.load && _ctx.load(...args)))
          }, "Try again")
        ]))
      : _createCommentVNode("", true)
}